import React from 'react';
import PropTypes from 'prop-types';

import { SlideSwitch } from '@els/els-react--slide-switch';

export default function SwitcherTo3D(props) {
  const { setEditorView, editorView } = props;

  return (
    <SlideSwitch
      data-e2e="3d-switcher"
      checked={editorView}
      onChange={(event) => setEditorView(event?.currentTarget?.checked)}
      label="View in 3D"
      className="e2e-3d-switcher"
    />
  );
}

SwitcherTo3D.propTypes = {
  setEditorView: PropTypes.func.isRequired,
  editorView: PropTypes.bool.isRequired,
};
